import { Component, OnInit, ViewChild, AfterViewInit, Input } from '@angular/core';
import { AnnouncementModel } from './Announcement.model';
import { ComboBoxComponent } from '../../../combo-box/combo-box.component';
import { DateComponent } from '../../../date/date.component';
import { ButtonComponent } from '../../../button/button.component';
import { FormComponent } from '../../../form/form.component';
import { ServiceStock } from '../../../service-stock.service';
import { HttpResponse } from '@angular/common/http';
import { GotxGridComponent } from '../../components/gotx-grid/gotx-grid.component';
import { StockComponent } from '../../components/Stock/Stock.component';

const customCss: string = '';

@Component({
    selector: 'app-Announcement',
    templateUrl: './Announcement.component.html'
})
export class AnnouncementComponent extends FormComponent implements OnInit, AfterViewInit {
    @ViewChild('dtFromDate', { static: false }) dtFromDate: DateComponent;
    @ViewChild('dtTodate', { static: false }) dtTodate: DateComponent;
    @ViewChild('cmbAnnouncementId', { static: false }) cmbAnnouncementId: ComboBoxComponent;
    @ViewChild('btnSubmit', { static: false }) btnSubmit: ButtonComponent;
    @ViewChild('announcementGrid', { static: false }) announcementGrid: GotxGridComponent;
    @ViewChild('cmbStock', { static: false }) cmbStock: StockComponent;

    @Input('params') params: any = null;
    skeletonContentLoaded = false;
    exchSymbol: any;
    selectedStock: any;
    symbol: string = '';
    cstmProduct: any;
    exchangeList: any;
    productList: any;
    productSelected = this.services.dataStore.getproductMasterData();

   
    async revalidate(): Promise<number> {
        var totalErrors = 0;
        // super.beforeRevalidate();
        await Promise.all([
            this.revalidateBasicField('dtFromDate', false, 'dtTodate'),
            this.revalidateBasicField('dtTodate', false, 'dtFromDate'),
            this.revalidateBasicField('cmbAnnouncementId'),
        ]).then((errorCounts) => {
            errorCounts.forEach((errorCount) => {
                totalErrors += errorCount;
            });
        });
        this.errors = totalErrors;
        // super.afterRevalidate();
        return totalErrors;
    }
    constructor(services: ServiceStock) {
        super(services);
        this.value = new AnnouncementModel();
        this.componentCode = 'Announcement';
        
    };
    setReadOnly(readOnly) {
        super.setBasicFieldsReadOnly(readOnly);
    }
    async onFormLoad() {
        this.setInputs(this.services.dataStore.getData(this.services.routing.currModal));
        this.dtFromDate.setValue(new Date());
        this.dtTodate.setValue(new Date());
        this.dtFromDate.setFocus(true);
        this.setDependencies();
        this.cmbAnnouncementId.setValue((1));
        // this.cmbStock.gotxInput.focus();
         if (this.params) {
            this.symbol = this.params.symbol;
            //   this.getQuoteAndSubscribe();
        }
        this.reloadStock();
    }
    setInputs(param: any) {
        let params = this.services.http.mapToJson(param);
        if (params['mode']) {
            this.mode = params['mode'];
        }
    }
    async submitForm(path, apiCode, serviceCode) {
        this.submitData['formName'] = 'Announcement';
        await super.submit(path, apiCode, serviceCode);
    }
    getFieldInfo() {
        this.amountComponent.forEach(field => { this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo(); });
        this.comboFields.forEach(field => { this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo(); });
        // this.fileUploadFields.forEach(field => { this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo(); });
        return this.additionalInfo;
    }
    getFieldValue() {
        return this.value;
    }
    setValue(inputValue, inputDesc = undefined) {
        this.setBasicFieldsValue(inputValue, inputDesc);
        this.value = new AnnouncementModel();
        this.value.setValue(inputValue);
        this.setDependencies();
        this.passNewValue(this.value);
    }
    setProductField(value: string): void {
        this.productSelected = value;
      }
    
    ngOnInit() {
        if (this.formCode == undefined) { this.formCode = 'Announcement'; }
        if (this.formOnLoadError) { return; }
        setTimeout(() => {
            this.skeletonContentLoaded = true;
        }, 1000);
        var styleElement = document.createElement('style');
        styleElement.type = 'text/css';
        styleElement.innerHTML = customCss;
        styleElement.id = 'Announcement_customCss';
        document.getElementsByTagName('head')[0].appendChild(styleElement);
        this.setProductField(this.productSelected);
    }
    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
        var styleElement = document.getElementById('Announcement_customCss');
        styleElement.parentNode.removeChild(styleElement);
    }
    ngAfterViewInit() {
        setTimeout(() => {
            this.subsBFldsValueUpdates();
            this.onFormLoad();
            this.checkForHTabOverFlow();
            this.btnSubmit_click();
        });
    }
    clearError() {
        super.clearBasicFieldsError();
        super.clearHTabErrors();
        super.clearVTabErrors();
        this.errors = 0;
        this.errorMessage = [];
    }
    onReset() {
        super.resetBasicFields();
        this.clearHTabErrors();
        this.clearVTabErrors();
        this.errors = 0;
        this.errorMessage = [];
        this.additionalInfo = undefined;
        this.dependencyMap.clear();
        this.value = new AnnouncementModel();
        this.passNewValue(this.value);
        this.setReadOnly(false);
        this.onFormLoad();
    }
    async cmbStock_stockSelected() {
        //console.log("Stock in Market Depth: ", this.cmbStock.gotxInput.val());
        let inputMap = new Map();
        this.reloadStock();
    }

    reloadStock() {
        //console.log("this.cmbStock",this.cmbStock);
        if (this.cmbStock) {
            this.cmbStock.gotxInput.val("");
            
            this.cmbStock.source = this.services.dataStore.getcmbStockInput(this.cmbStock.searchMode, "CTG", this.productSelected, "AL");
            //console.log("this.cmbStock.source",this.cmbStock.source);
        }
    }
     
    async btnSubmit_click() {
        let inputMap = new Map();
        var errorCount: number = await this.revalidate();
        document.getElementById('errMsgDiv').innerHTML = "";

        // delete start
        // let res = { "respCode": "0", "errMsg": "", "response": [
        //     { "routingType": "5", "participantId": "KABIR", "subject": "test iws", "priority": "1", "exchange": "", "publishDate": 20221111, "publishTime": 155952075507, "message": "TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST", "exchangeSymbol": "CBLPBOND" }, { "routingType": "5", "participantId": "KABIR", "subject": "test iws", "priority": "1", "exchange": "", "publishDate": 20221111, "publishTime": 155953093699, "message": "test iws news", "exchangeSymbol": "CBLPBOND " }, { "routingType": "5", "participantId": "KABIR", "subject": "test iws 2", "priority": "1", "exchange": "CBLPBOND", "publishDate": 20221111, "publishTime": 160110942067, "message": "test iws news 2", "exchangeSymbol": "CBLPBOND " }, { "routingType": "5", "participantId": "KABIR", "subject": "test iws 3", "priority": "1", "exchange": "", "publishDate": 20221111, "publishTime": 160152996613, "message": "test iws news 3", "exchangeSymbol": "AAMRANET " },
        //     { "routingType": "5", "participantId": "KABIR", "subject": "test iws", "priority": "1", "exchange": "", "publishDate": 20221111, "publishTime": 155952075507, "message": "TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST MESSAGE TEST", "exchangeSymbol": "CBLPBOND " }, { "routingType": "5", "participantId": "KABIR", "subject": "test iws", "priority": "1", "exchange": "", "publishDate": 20221111, "publishTime": 155953093699, "message": "test iws news", "exchangeSymbol": "CBLPBOND " }, { "routingType": "5", "participantId": "KABIR", "subject": "test iws 2", "priority": "1", "exchange": "CBLPBOND", "publishDate": 20221111, "publishTime": 160110942067, "message": "test iws news 2", "exchangeSymbol": "CBLPBOND " }, { "routingType": "5", "participantId": "KABIR", "subject": "test iws 3", "priority": "1", "exchange": "", "publishDate": 20221111, "publishTime": 160152996613, "message": "test iws news 3", "exchangeSymbol": "CBLPBOND " }
        // ], "sessionResponse": null, "target": null };
        // var resp = res['response'];
        // resp.forEach(element => {
        //     element["publishDateStr"] = this.services.timePipe.dateConversion(element.publishDate.toString());
        //     element["publishTimeStr"] = this.services.timePipe.transform(element.publishTime);
        // });
        // this.announcementGrid.reloadGrid(resp);
        // delete end

        if (errorCount == 0) {
            //  console.log("in");
            // this.symbol = this.getSymbol();
            inputMap.clear();
            inputMap.set('Body.startDate', this.services.dataStore.dateToDateString(this.dtFromDate.getFieldValue()));
            inputMap.set('Body.endDate', this.services.dataStore.dateToDateString(this.dtTodate.getFieldValue()));
            inputMap.set('Body.endTime', "000000");
            inputMap.set('Body.routingType', this.cmbAnnouncementId.getFieldValue());

            let _usym: string = "ALL";
            let _key: string = 'CTG' + "#" + this.productSelected + "#" + 'NR' + "#";
            if (typeof this.cmbStock.gotxInput.val() === 'object') {
                // inputMap.set('Body.exchangeSymbol', this.cmbStock.gotxInput.val().label);
                _key += this.cmbStock.gotxInput.val().label;
            } else {
                // inputMap.set('Body.exchangeSymbol', this.cmbStock.gotxInput.val());
                _key += this.cmbStock.gotxInput.val();
            }
            if (this.services.dataStore.stockMasterMap.get(_key)) {
                _usym = this.services.dataStore.stockMasterMap.get(_key).exchSymbol;
            }
            inputMap.set('Body.exchangeSymbol', _usym);  // default "ALL"

            this.services.http.fetchApi('/market/news/query', 'POST', inputMap).subscribe(
                async (httpResponse: HttpResponse<any>) => {
                    var res = httpResponse.body;
                    var respCode: any = res['respCode'];

                    if (respCode != null && respCode == 0) {
                        var resp = res['response'];
                        resp.forEach(element => {
                            element["publishDateStr"] = this.services.timePipe.dateConversion(element.publishDate.toString());
                            element["publishTimeStr"] = this.services.timePipe.transform(element.publishTime);
                        });
                        // this.announcementGrid.reloadGrid(resp); // grid taking very long time to render data, making the Page Unresponsive. 08jun2023:ssr
                        this.announcementGrid.source.localdata = resp;
                        this.announcementGrid.gotxGrid.pageable(true);
                        this.announcementGrid.gotxGrid.pagesize(30);
                        this.announcementGrid.gotxGrid.updatebounddata();
                        //console.log("this.cmbStock.gotxInput.val()",this.cmbStock.gotxInput.val());
                        this.cmbStock.gotxInput.val("");
                        //console.log("stock value after",this.cmbStock.gotxInput.val());

                    } else {
                        //this.services.alert.showAlert(1, "Sucess", 2000);
                        //document.getElementById('errMsgDiv').innerHTML = res['errMsg'];
			//commented by Shanmuga Priya - VAPT
			const rawMsg = res['errMsg'];
			const plainMsg = rawMsg.replace(/<[^>]*>/g, ""); // remove HTML tags
			(document.getElementById('errMsgDiv') as HTMLElement).textContent = plainMsg;
                    }
                },
                async (httpError) => {
                    var err = httpError['error']
                    if (err != null && err['ErrorElementPath'] != undefined && err['ErrorDescription'] != undefined) {
                        if (err['ErrorElementPath'] == 'routingType') {
                            this.cmbAnnouncementId.setError(err['ErrorDescription']);
                        }
                        else if (err['ErrorElementPath'] == 'endDate') {
                            this.dtTodate.setError(err['ErrorDescription']);
                        }
                        else if (err['ErrorElementPath'] == 'startDate') {
                            this.dtFromDate.setError(err['ErrorDescription']);
                        }
                    }
                    document.getElementById('errMsgDiv').innerHTML = this.transalte('ErrorCodes.SystemDown');
                }
            );
        }
    }
    linkrenderer = (row: number) => {
        var priority = this.announcementGrid.gotxGrid.getrowdata(row).priority;
        if (priority == "1") {
            return "<div  class='jqx-grid-cell-centerAlignment' id ='High' >High</div>";
        } else if (priority == "2") {
            return "<div   id ='Medium' class='jqx-grid-cell-centerAlignment'>Medium</div>";
        } else if (priority == "3") {
            return "<div  id ='Low' class='jqx-grid-cell-centerAlignment'>Low</div>";
        }
    };
    sourceRenderer = (row: number) => {
        var routingType = this.announcementGrid.gotxGrid.getrowdata(row).routingType;
        var participant = this.announcementGrid.gotxGrid.getrowdata(row).participantId;
        if (routingType == "1") {
            return "<div class='jqx-grid-cell-centerAlignment'>Market</div>";
        } else {
            return "<div class='jqx-grid-cell-centerAlignment' ' id='participantName'>" + participant + "</div>";
        };
    }

    transalte(text) {
        return this.services.translate.instant(text);
    }
    // rowId = "exchangeSymbol";
    datafields = [
        { name: 'priority', type: 'string' },
        { name: 'publishDate', type: 'string' },
        { name: 'publishTime', type: 'string' },
        { name: 'participantId', type: 'string' },
        { name: 'exchangeSymbol', type: 'string' },
        { name: 'subject', type: 'string' },
        { name: 'message', type: 'string' },
        { name: 'routingType', type: 'string' },
        { name: 'publishDateStr', type: 'string' },
        { name: 'publishTimeStr', type: 'string' }
    ];

    datatype = "json";
    data = [];
    
    columns: any[] = [
        { text: this.transalte('MarketNewsGrid.Priority'), align: 'center', cellsalign: 'right', width: "8%", cellsrenderer: this.linkrenderer },
        { text: this.transalte('MarketNewsGrid.Date'), datafield: 'publishDateStr', width: "8%", cellsalign: 'left', align: 'center' },
        { text: this.transalte('MarketNewsGrid.TimeStamp'), datafield: 'publishTimeStr', width: "8%", cellsalign: 'left', align: 'center' },
        { text: this.transalte('MarketNewsGrid.Source'), align: 'center', cellsalign: 'right', width: "8%", cellsrenderer: this.sourceRenderer },
        { text: this.transalte('MarketNewsGrid.Symbol'), datafield: 'exchangeSymbol', width: "10%", cellsalign: 'left', align: 'center' },
        // { text: this.transalte('MarketNewsGrid.Symbol'), filtertype: 'custom', 
        //     createfilterpanel: (datafield: string, filterPanel: any): void => { this.buildFilterPanel(filterPanel, datafield); }, datafield: 'exchangeSymbol', width: "10%", cellsalign: 'left', align: 'center' },
        { text: this.transalte('MarketNewsGrid.Subject'), datafield: 'subject', width: "18%", cellsalign: 'left', align: 'center' },
        { text: this.transalte('MarketNewsGrid.Message'), datafield: 'message', width: "40%", cellsalign: 'left', align: 'center' },
        // {
        //     text: this.transalte('MarketNewsGrid.Message'), datafield: 'message', width:"32%",
        //     cellsrenderer: function (row, datafield, value) {
        //             let cellValueContainer = "<div class='cellClass'> " + value + "</div>";
        //             return cellValueContainer;
        //     }
        // },
        { text: 'routingType', datafield: 'routingType', width: "40%", cellsalign: 'left', align: 'center', hidden: true }
    ];

    // custom filter panel
    buildFilterPanel = (filterPanel: any, datafield: string): void => {
        let inputContainer = document.createElement('input');
        inputContainer.id = 'inputContainer';
        inputContainer.style.margin = '5px';
        let buttonsContainer = document.createElement('div');
        buttonsContainer.className = 'filter';
        Object.assign(buttonsContainer.style, { height: '25px', marginLeft: '20px', marginTop: '7px' })
        let filterButtonContainer = document.createElement('div');
        let filterClearButtonContainer = document.createElement('div');
        filterButtonContainer.style.cssText = 'margin-left: 16px; float: left';
        filterClearButtonContainer.style.cssText = 'margin-left: 12px; float: left';
        filterButtonContainer.id = 'filterButtonContainer';
        filterClearButtonContainer.id = 'filterClearButtonContainer';
        buttonsContainer.appendChild(filterButtonContainer);
        buttonsContainer.appendChild(filterClearButtonContainer);
        filterPanel[0].appendChild(inputContainer);
        filterPanel[0].appendChild(buttonsContainer);
        let filterButtonOptions = { width: 45, height: 25, value: 'Filter' };
        let filterButton = jqwidgets.createInstance('#filterButtonContainer', 'jqxButton', filterButtonOptions);
        let filterClearButtonOptions = { width: 45, height: 25, value: 'Clear' };
        let filterClearButton = jqwidgets.createInstance('#filterClearButtonContainer', 'jqxButton', filterClearButtonOptions);
        let dataSource =
            {
                localdata: this.announcementGrid.dataAdapter.records,
                datatype: 'array',
                async: false
            }
        let dataadapter = new jqx.dataAdapter(dataSource,
            {
                autoBind: false,
                autoSort: true,
                autoSortField: datafield,
                async: false,
                uniqueDataFields: [datafield]
            });
        let column = this.announcementGrid.gotxGrid.getcolumn(datafield);
        let inputOptions = {
            width: 160, height: 20, source: dataadapter,
            displayMember: 'datafield', popupZIndex: 99999,
            placeHolder: `Enter ${column.text}`
        }
        let input = jqwidgets.createInstance('#inputContainer', 'jqxInput', inputOptions);
        filterButton.addEventHandler('click', () => {
            let filtergroup = new jqx.filter();
            let filter_or_operator = 1;
            let filtervalue = input.val();
            let filtercondition = 'contains';
            let filter1 = filtergroup.createfilter('stringfilter', filtervalue, filtercondition);
            filtergroup.addfilter(filter_or_operator, filter1);
            // add the filters.
            this.announcementGrid.gotxGrid.addfilter(datafield, filtergroup);
            // apply the filters.
            this.announcementGrid.gotxGrid.applyfilters();
            this.announcementGrid.gotxGrid.closemenu();
        });
        filterClearButton.addEventHandler('click', () => {
            this.announcementGrid.gotxGrid.removefilter(datafield, false);
            // apply the filters.
            this.announcementGrid.gotxGrid.applyfilters();
            this.announcementGrid.gotxGrid.closemenu();
        });
    }
    

}